import React, { useEffect } from 'react'

import { stateOpt } from '../../../utilities/helpers'

import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Stack from 'react-bootstrap/Stack'

import { Error } from '../../Error'

export default function OrganizationInformation({
  org,
  setName,
  handleAddress,
  error,
  isReadOnly,
}) {
  useEffect(() => {}, [])

  return (
    <>
      <Form.Group className="form-group" controlId="name">
        <Form.Label>Organization name</Form.Label>
        <Form.Control
          type="text"
          name="name"
          required
          readOnly={isReadOnly}
          data-testid="organization-info-org-name"
          placeholder="Enter organization name"
          value={org?.name}
          onChange={setName}
          className={error?.type === 'alreadyExist' ? 'error-border' : ''}
        />
      </Form.Group>
      <fieldset className="form-group">
        <legend className="form-label">Address</legend>
        <Stack gap={2}>
          <Form.Control
            type="text"
            name="address_1"
            required
            readOnly={isReadOnly}
            aria-label="Address"
            placeholder="Address"
            value={org?.address?.address_1}
            onChange={handleAddress}
          />
          <Form.Control
            type="text"
            name="city"
            required
            readOnly={isReadOnly}
            aria-label="City"
            placeholder="City"
            value={org?.address?.city}
            onChange={handleAddress}
          />
          <Row>
            <Col md={4}>
              <Form.Control
                type="text"
                name="zipcode"
                required
                readOnly={isReadOnly}
                aria-label="Zip Code"
                placeholder="Zip code"
                value={org?.address?.zipcode}
                onChange={handleAddress}
              />
            </Col>
            <Col className="ps-0">
              <Form.Select
                aria-label="State"
                required
                readOnly={isReadOnly}
                value={org?.address?.state}
                onChange={handleAddress}
                name="state"
              >
                {stateOpt.map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.name}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>
        </Stack>
      </fieldset>
      {error?.type && (
        <Error
          type={error?.type}
          field={error?.field}
          message={error?.message}
        />
      )}
    </>
  )
}
